module.exports = __webpack_public_path__ + "img/home-eclectic-living.3610cdcd.jpg";